import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authSlice from './feature/authSlice';
import categoriesSlice from './feature/categoriesSlice';
import productsSlice from './feature/productsSlice';
import productTypeSlice from './feature/productTypeSlice';
import { categoriesApi } from './services/categories';
import { productTypeApi } from './services/product_type';
import { productsApi } from './services/products';
import { cartApi } from './services/cart';
import { wishlistApi } from './services/wishlist';
import { ProfileApi } from './services/profile';
import { productPropertiesApi } from './services/product_properties';
import { ordersApi } from './services/orders';

const authPersistConfig = {
  key: 'auth',
  storage,
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authSlice),
  categories: categoriesSlice,
  products: productsSlice,
  product_type: productTypeSlice,
  [categoriesApi.reducerPath]: categoriesApi.reducer,
  [productTypeApi.reducerPath]: productTypeApi.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [wishlistApi.reducerPath]: wishlistApi.reducer,
  [ProfileApi.reducerPath]: ProfileApi.reducer,
  [productPropertiesApi.reducerPath]: productPropertiesApi.reducer,
  [ordersApi.reducerPath]: ordersApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      categoriesApi.middleware,
      productTypeApi.middleware,
      productsApi.middleware,
      cartApi.middleware,
      wishlistApi.middleware,
      ProfileApi.middleware,
      productPropertiesApi.middleware,
      ordersApi.middleware,
    )
});

export const persistor = persistStore(store);
